export const getExitingLoaderTheme = (theme: string, isElectron: boolean) => {
  const isDark = theme === "website-theme" || theme === "editor-dark-theme";

  if (isElectron) {
    return isDark
      ? {
          exitBg: "radial-gradient(circle at center, #1a1a24 0%, #0f0f14 100%)",
          cardBg: "rgba(30, 30, 42, 0.45)",
          cardBorder: "1px solid rgba(91, 91, 240, 0.15)",
          cardShadow: "0 20px 50px rgba(0, 0, 0, 0.5), 0 0 40px rgba(91, 91, 240, 0.05)",
          accentColor: "#5b5bf0",
          spinnerBorder: "3px solid rgba(91, 91, 240, 0.1)",
          spinnerShadow: "0 0 15px rgba(91, 91, 240, 0.2)",
          iconBg: "rgba(91, 91, 240, 0.1)",
          iconBorder: "1px solid rgba(91, 91, 240, 0.25)",
          titleColor: "#ffffff",
          subtextColor: "#8b8ba0",
        }
      : {
          exitBg: "radial-gradient(circle at center, #f5f5fa 0%, #e5e5ef 100%)",
          cardBg: "rgba(255, 255, 255, 0.85)",
          cardBorder: "1px solid rgba(79, 70, 229, 0.15)",
          cardShadow: "0 20px 50px rgba(0, 0, 0, 0.08), 0 0 40px rgba(79, 70, 229, 0.05)",
          accentColor: "#4f46e5",
          spinnerBorder: "3px solid rgba(79, 70, 229, 0.1)",
          spinnerShadow: "0 0 15px rgba(79, 70, 229, 0.2)",
          iconBg: "rgba(79, 70, 229, 0.1)",
          iconBorder: "1px solid rgba(79, 70, 229, 0.25)",
          titleColor: "#1a1a2e",
          subtextColor: "#6b7280",
        };
  }

  // Web fallback (original colors)
  return isDark
    ? {
        exitBg: "radial-gradient(circle at center, #111d15 0%, #080f0b 100%)",
        cardBg: "rgba(16, 28, 20, 0.45)",
        cardBorder: "1px solid rgba(126, 217, 87, 0.15)",
        cardShadow: "0 20px 50px rgba(0, 0, 0, 0.5), 0 0 40px rgba(126, 217, 87, 0.05)",
        accentColor: "#7ed957",
        spinnerBorder: "3px solid rgba(126, 217, 87, 0.1)",
        spinnerShadow: "0 0 15px rgba(126, 217, 87, 0.2)",
        iconBg: "rgba(126, 217, 87, 0.1)",
        iconBorder: "1px solid rgba(126, 217, 87, 0.25)",
        titleColor: "#ffffff",
        subtextColor: "#a0aec0",
      }
    : {
        exitBg: "radial-gradient(circle at center, #f4f6fa 0%, #e2e8f0 100%)",
        cardBg: "rgba(255, 255, 255, 0.85)",
        cardBorder: "1px solid rgba(66, 153, 225, 0.15)",
        cardShadow: "0 20px 50px rgba(0, 0, 0, 0.08), 0 0 40px rgba(66, 153, 225, 0.05)",
        accentColor: "#4299e1",
        spinnerBorder: "3px solid rgba(66, 153, 225, 0.1)",
        spinnerShadow: "0 0 15px rgba(66, 153, 225, 0.2)",
        iconBg: "rgba(66, 153, 225, 0.1)",
        iconBorder: "1px solid rgba(66, 153, 225, 0.25)",
        titleColor: "#1a202c",
        subtextColor: "#4a5568",
      };
};
